import { CognitoAuthService } from "../services/cognitoService";
import { setStoredIdToken } from "./tokenStore";
import { debug } from "../utils/debugLogger";

/**
 * Get a new ID token so it lists the caller's current Brands.
 *
 * Backend services decide Brand access from the token's `sagelyn_brands` claim
 * (written by customer-management's Pre Token Generation trigger), not from a
 * database. A token issued before a Brand existed does not list it, so every
 * call for that Brand would 403 until the hourly refresh. Call this right after
 * anything that grants the current user a Brand (creating one, accepting an
 * invite).
 *
 * Writes the token store only (not React state), like the routine refresh; the
 * axios interceptor and authedFetch read the store, so every later request uses
 * the new token. A failure is logged and rethrown: the caller decides whether
 * to tell the user, but it must not pretend access is ready.
 */
export async function refreshBrandAccess(): Promise<string> {
  try {
    const token = await CognitoAuthService.forceRefresh();
    setStoredIdToken(token);
    return token;
  } catch (error) {
    debug.error("refreshBrandAccess: could not get a new token", error);
    throw error;
  }
}
